// extracted by mini-css-extract-plugin
export default {"container":"layout_container__VaXdQ","header-container":"layout_header-container__+F+vo"};